// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eBXjH","icon":"styles_icon__5jODa"};